import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IPolicyInfo } from 'obt-common';
import { RateOptionTicketType } from 'obt-common/types/api/v1/obt/air/air_search_response';

import { FlightOutOfPolicyLabel } from 'src/app/flights/shared/FlightOutOfPolicyLabel';
import PolicyContent from './PolicyContent';
import PolicyModal from './PolicyModal/index';

interface IProps {
  isOutOfPolicy: boolean;
  policyInfo: IPolicyInfo;
  ticketType: RateOptionTicketType;
  onOOPClick?: VoidFunction;
}

const OutOfPolicyModal = ({ policyInfo, ticketType, isOutOfPolicy, onOOPClick }: IProps): JSX.Element => {
  const { t: tt } = useTranslation('WEB');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePolicyLabelClick = (): void => {
    onOOPClick?.();
    setIsModalOpen(true);
  };

  const handleModalClose = (): void => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <Fragment>
      <FlightOutOfPolicyLabel
        ticketType={ticketType}
        handlePolicyLabelClick={handlePolicyLabelClick}
        isOutOfPolicy={isOutOfPolicy}
      />

      <PolicyModal isOpen={isModalOpen} onClose={handleModalClose} title={tt('Things you should know')}>
        <PolicyContent
          isOutOfPolicy={[isOutOfPolicy]}
          policyInfos={[policyInfo]}
          ticketType={ticketType}
          showOnlyOutofPolicy={false}
        />
      </PolicyModal>
    </Fragment>
  );
};

export default OutOfPolicyModal;
